import React, { useState } from 'react'
import './userlogin.scss'
import { useHistory } from 'react-router-dom'

const NewPassword = () => {

    const search = window.location.search;
    const paramss = new URLSearchParams(search);

    const [error, setError] = useState(false)
    const [password, setPassword] = useState('');
    const [passwordRepeat, setPasswordRepeat] = useState('');
    const [passwordError, setPasswordError] = useState("");
    const [passwordRepeatError, setPasswordRepeatError] = useState("");
    const [noPasswordMatch, setNoPasswordMatch] = useState()
    const history = useHistory();

   

    const handleSubmit = (event) => {
        event.preventDefault()
       
        if (password === '' || passwordRepeat === '') {
            setError(true)
            setPasswordError('udfyld venligst ny adgangskode')
            setPasswordRepeatError('gentag venligst ny adgangskode igen')
        }
        else if (password.length && passwordRepeat.length && password !== passwordRepeat) {
            setError(true)
            setNoPasswordMatch('adgangskode matcher ikke')

        }
        else {
            let email = paramss.get('email')
            let uid = paramss.get('guid')
            fetch(`http://dev.ebillet.dk/systemnative/customer.asmx/ResetPassword?Email=${email}&NewPassword=${password}&guid=${uid}`, {
                method: "GET",
            })
                .then((res) => res.json())
                .then((result) => {
                    console.log(result, 'result')

                    if (result.result === 1) {
                        history.push('/profile', {
                            login_info: result.login,
                            transaction: result.transactionsPrYear[0],
                            newsgroup: result.Newsgroups,
                            reservations: result.Reservations,
                            key: result.key
                        })
                    }
                })
           
        }
       
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value)
        setPasswordError('')
        setError(false)
    }

    const handleRepeatPasswordChange = (e) => {
        setPasswordRepeat(e.target.value)
        setPasswordRepeatError('')
        setError(false)

    }

    return (
        <>
           
         
        <div className="login" >
            <p className='profile'>Din profil</p>
            <p className='emailtext'>Indtast ny adgangskode</p>
           

            <form onSubmit={(e)=>handleSubmit(e)} style={{ marginTop: '30px' }}>
                        <label>Ny Adgangskode</label>
                        <input className='password' type='password' onChange={handlePasswordChange}></input>
                        <label>Gentag ny adgangskode</label>
                        <input type='password' onChange={handleRepeatPasswordChange}></input>
              
          
                    <button type="submit" className='send_btn' >Gem ny adgangskode</button>
            </form>
            {error === true ?
                <div className='error-div'>

                        {passwordError &&       <span>{passwordError}</span>}
                        {passwordRepeatError && <span>{passwordRepeatError}</span>}
                        {noPasswordMatch &&     <span>{noPasswordMatch}</span>}
                </div> : null}
            </div>
                
        </>
            )
}

export default NewPassword